/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Button } from "antd-mobile";
import { FormattedMessage, injectIntl } from "react-intl";
import Theme from "../../../utils/Theme";
import PinInput from "../../../components/PinInput";
import { millisecondsToTime } from "../../../utils/DateTimeManager";

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const StyledTitle = styled.span`
  font-size: 1.4em;
  line-height: 2.1em;
  font-weight: 900;
`;

const StyledDescription = styled.span`
  margin-top: 3%;
  color: grey;
  font-size: 0.9em;
  line-height: 1.3em;
`;

const StyledButton = styled(Button)`
  margin-top: 3%;
  width: 100%;
  box-shadow: 0 4px 6px -5px grey;
  && {
    cursor: pointer;
    font-size: 1em
    border-radius: 25px;
    color: white;
    background-color: ${props =>
      props.disabled ? "grey" : Theme.PrimaryColor};
  }
`;

const StyledCountdownContainer = styled.div`
  margin-top: 7%;
  display: flex;
  flex-direction: row;
  justify-contnet: center;
  align-items: center;
`;

const StyledErrorMesage = styled.span`
  margin-top: 2%;
  font-size: 0.8em;
  color: red;
  height: 1em;
`;

const StyledStatus = styled.span`
  font-size: 0.8em;
  color: ${Theme.SecondaryColor};
`;

const StyledCountdownBtn = styled.div`
  margin-left: 5px;
  font-weight: bold;
  font-size: 0.9em;
  color: red;
`;

class VerifyCodeSection extends Component {
  constructor(props) {
    super(props);
  }

  onResendClicked = () => {
    const { onResendClicked } = this.props;

    onResendClicked && onResendClicked();
  };

  render() {
    const {
      countdown,
      loading,
      error,
      code,
      onCodeChanged,
      onSubmit
    } = this.props;

    return (
      <StyledContainer>
        <StyledTitle>
          <FormattedMessage
            id="verify.title"
            defaultMessage="Verify Mobile Number"
            description="Verify Mobile Number Title"
          />
        </StyledTitle>
        <StyledDescription>
          <FormattedMessage
            id="verify.description"
            defaultMessage="Please key in the code sent via SMS within the next one minutes, or you will received an automated reminder via phone call."
            description="Verify Mobile Number Description"
          />
        </StyledDescription>
        <PinInput
          defaultValue={code}
          length={4}
          type="numeric"
          style={{ marginTop: "8%" }}
          inputStyle={{
            border: "1px solid lightgray",
            fontSize: "1em",
            fontWeight: 900,
            color: "black"
          }}
          inputFocusStyle={{
            borderBottom: "5px solid " + Theme.PrimaryColor
          }}
          onChange={value => onCodeChanged && onCodeChanged(value)}
        />
        <StyledErrorMesage>{error ? error : ""}</StyledErrorMesage>
        <StyledButton
          disabled={loading || code.length !== 4}
          loading={loading}
          activeStyle={{ backgroundColor: Theme.ActivePrimary }}
          onClick={() => onSubmit && onSubmit()}
        >
          {loading ? (
            <FormattedMessage
              id="app.loading"
              defaultMessage="Loading"
              description="Loading Title"
            />
          ) : (
            <FormattedMessage
              id="register.next.btn"
              defaultMessage="NEXT >"
              description="Register Page Next Btn Title"
            />
          )}
        </StyledButton>
        <StyledCountdownContainer>
          <StyledStatus>
            {countdown === 0 ? (
              <FormattedMessage
                id="verify.resend.didnt.receive"
                defaultMessage="Did not receive the SMS? "
                description="Verify Mobile Num No Receive SMS Title"
              />
            ) : (
              <FormattedMessage
                id="verify.resend.countdown"
                defaultMessage="Resend new code in "
                description="Verify Mobile Num New Code In Title"
              />
            )}
          </StyledStatus>
          <StyledCountdownBtn
            className={"underline"}
            onClick={() => countdown === 0 && this.onResendClicked()}
          >
            {countdown === 0 ? (
              <FormattedMessage
                id="verify.resend.title"
                defaultMessage="Resend new code"
                description="Verify Mobile Num Resend New Code Title"
              />
            ) : (
              millisecondsToTime(countdown * 1000)
            )}
          </StyledCountdownBtn>
        </StyledCountdownContainer>
      </StyledContainer>
    );
  }
}

VerifyCodeSection.propTypes = {
  intl: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  countdown: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  onCodeChanged: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onResendClicked: PropTypes.func.isRequired
};

VerifyCodeSection.defaultProps = {
  loading: false,
  error: null,
  code: "",
  onCodeChanged: null,
  onSubmit: null,
  onResendClicked: null
};

export default injectIntl(VerifyCodeSection);



// WEBPACK FOOTER //
// ./src/containers/RegisterPage/VerifyCodeSection/index.js